export function removerAcentos(texto: string): string {
  return texto?.replace(/\s/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}